<template>
  <el-aside :width="isCollapsed ? '10px' : '200px'">
    <div class="aside-logo">
      <!-- <img src="../static/logo.png" height="60px" alt="icon" /> -->
      <img
        :src="
          isCollapsed
            ? this.baseUrl + 'img/self-s.png'
            : this.baseUrl + 'img/self-l.png'
        "
        @click="toggleCollapse"
        :title="isCollapsed ? '打开菜单' : '折叠菜单'"
      />
      <!-- <span>基础信息监控平台</span> -->
      <!-- <div
        class="toggleCollapse"
        @click="toggleCollapse"
        :title="isCollapsed ? '打开菜单' : '折叠菜单'"
      >
        <i
          :class="isCollapsed ? 'el-icon-caret-right' : 'el-icon-caret-left'"
        ></i>
      </div> -->
    </div>

    <el-menu
      default-active="1"
      class="el-menu-vertical-demo"
      background-color="#111217"
      text-color="#fff"
      active-text-color="#409EFF"
      :collapse-transition="false"
      :collapse="isCollapsed"
      router
    >
      <el-menu-item index="welcome">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>主页</span>
        </template>
      </el-menu-item>
      <el-submenu index="1">
        <template slot="title">
          <i class="el-icon-setting"></i>
          <span>TOPO</span>
        </template>
        <el-menu-item-group class="sub_title" title="机房信息">
          <el-menu-item index="all_DC_info">
            <i class="el-icon-caret-right"></i>
            <span>园区一览</span>
          </el-menu-item>
          <el-menu-item index="DC_GR_1F">
            <i class="el-icon-caret-right"></i>
            <span>感染1F汇聚机房</span>
          </el-menu-item>
          <el-menu-item index="DC_ZH_3F">
            <i class="el-icon-caret-right"></i>
            <span>综合3F汇聚机房</span>
          </el-menu-item>
          <el-menu-item index="DC_ZH_5F">
            <i class="el-icon-caret-right"></i>
            <span>综合5F机房</span>
          </el-menu-item>
          <el-menu-item index="DC_ZH_1F">
            <i class="el-icon-caret-right"></i>
            <span>综合1F物联网机房</span>
          </el-menu-item>
          <el-menu-item index="DC_HQ_5F">
            <i class="el-icon-caret-right"></i>
            <span>后勤5F冗余机房</span>
          </el-menu-item>
          <el-menu-item index="DC_ZY_3">
            <i class="el-icon-caret-right"></i>
            <span>住院③汇聚机房</span>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group title="网络拓扑">
          <el-menu-item index="Network_all">
            <i class="el-icon-caret-right"></i>
            <span>网络图</span>
          </el-menu-item>
          <!-- <el-menu-item index="topoLOL0815">
            <i class="el-icon-caret-right"></i>
            <span>LOL数据中心2</span>
          </el-menu-item>
          <el-menu-item index="topoDataCenter">
            <i class="el-icon-caret-right"></i>
            <span>数据中心环控</span>
          </el-menu-item>
          <el-menu-item index="topoCabinetA">
            <i class="el-icon-caret-right"></i>
            <span>数据中心详情</span>
          </el-menu-item> -->
        </el-menu-item-group>
      </el-submenu>

      <!-- <el-submenu index="2">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>设备详情</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="infoServer">
            <i class="el-icon-caret-right"></i>
            <span>服务器设备</span>
          </el-menu-item>
          <el-menu-item index="infoSwitch">
            <i class="el-icon-caret-right"></i>
            <span>网络设备</span>
          </el-menu-item>
          <el-menu-item index="infoFW">
            <i class="el-icon-caret-right"></i>
            <span>安全设备</span>
          </el-menu-item>
          <el-menu-item index="infoUPS">
            <i class="el-icon-caret-right"></i>
            <span>配电及UPS</span>
          </el-menu-item>
          <el-menu-item index="infoAirCondictioner">
            <i class="el-icon-caret-right"></i>
            <span>空调设备</span>
          </el-menu-item>
          <el-menu-item index="infoStorage">
            <i class="el-icon-caret-right"></i>
            <span>存储设备 (建设中)</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="3">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>事件报告</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="reportEventTimesAll">
            <i class="el-icon-caret-right"></i>
            <span>事件统计</span>
          </el-menu-item>
          <el-menu-item index="reportEventDetail">
            <i class="el-icon-caret-right"></i>
            <span>事件详情</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

      <el-submenu index="4">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>大屏样式</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="zabbix_dashboard_1">
            <i class="el-icon-caret-right"></i>
            <span>运维平台一</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="5">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span>其他</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="software_detail">
            <i class="el-icon-caret-right"></i>
            <span>软件说明</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu> -->
      <el-menu-item index="/">
        <template slot="title">
          <i class="el-icon-document"></i>
          <span @click="logonOut('loginForm')">退出</span>
        </template>
      </el-menu-item>
    </el-menu>
  </el-aside>
</template>
  
  <script>
import { Url } from "../config/env";
export default {
  data() {
    return {
      isCollapsed: true,
      baseUrl: Url,
    };
  },
  components: {},
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    logonOut() {
      sessionStorage.setItem("logon", 0);
      this.$message({
        type: "success",
        message: "退出成功",
      });
      this.$router.push("/");
    },
  },
};
</script>
  <style lang="less" scoped>
@import "../style/common";
@import "../style/mixin";
.el-aside {
  display: flex;
  flex-direction: column;
  background-color: #111217;
  > .aside-logo {
    // background-color: #111217;
    > img {
      width: 100%;
      position: relative;
      // left: 50%;
      // margin-left: -30px;
    }
  }
}
.el-menu {
  height: 100%;
  border-right: none;
}
//一级菜单样式
.el-submenu /deep/ .el-submenu__title {
  span {
    font-size: 20px;
  }
}
.el-menu-item {
  span {
    font-size: 20px;
  }
}
//二级菜单标题样式
.el-menu-item-group /deep/ .el-menu-item-group__title {
  font-size: 18px;
}
//二级菜单样式
.el-menu-item-group /deep/ .el-menu-item {
  font-size: 18px;
}
.el-menu-item {
  color: #fff;
}
.toggleCollapse {
  // position: absolute;
  // top: 20px;
  background-color: #111217;
  color: #fff;
  font-size: 22px;
  line-height: 24px;
  text-align: right;
}
</style>
  